import SafeSearchTerms from "../../../../src/mdx/trust-and-safety/safe-search-terms.mdx";
import * as React from 'react';
export default {
  SafeSearchTerms,
  React
};